import performance from '../performance/performance';
import Times from '../times/times';
export var CODE_PARSING_PHASE_NAME = 'code-parsing-phase';

var LoadingPhases = /*#__PURE__*/function () {
  function LoadingPhases(appName, times) {
    this.appName = appName;
    this.phases = new Map();
    this.indexToKey = new Map();
    this.times = times || new Times(appName);
  }

  LoadingPhases._getIndexForPhase = function _getIndexForPhase(_ref) {
    var name = _ref.name,
        _ref$appId = _ref.appId,
        appId = _ref$appId === void 0 ? '' : _ref$appId,
        _ref$widgetId = _ref.widgetId,
        widgetId = _ref$widgetId === void 0 ? '' : _ref$widgetId;
    return name + "_" + appId + "_" + widgetId;
  };

  var _proto = LoadingPhases.prototype;

  _proto.getAppLoadingPhaseData = function getAppLoadingPhaseData(_ref2) {
    var name = _ref2.name,
        appId = _ref2.appId,
        widgetId = _ref2.widgetId;
    return this.phases.get(LoadingPhases._getIndexForPhase({
      name: name,
      appId: appId,
      widgetId: widgetId
    }));
  };

  _proto.saveLoadingPhase = function saveLoadingPhase(_ref3) {
    var name = _ref3.name,
        appId = _ref3.appId,
        widgetId = _ref3.widgetId;

    var phaseKey = LoadingPhases._getIndexForPhase({
      name: name,
      appId: appId,
      widgetId: widgetId
    });

    if (!this.phases.has(phaseKey)) {
      var index = this.phases.size;
      this.phases.set(phaseKey, {
        name: name,
        phaseStartTime: performance.now(),
        index: index
      });
      this.indexToKey.set(index, phaseKey);
    }
  };

  _proto.endLoadingPhase = function endLoadingPhase(_ref4) {
    var name = _ref4.name,
        appId = _ref4.appId,
        widgetId = _ref4.widgetId,
        widgetArray = _ref4.widgetArray;

    var phaseKey = LoadingPhases._getIndexForPhase({
      name: name,
      appId: appId,
      widgetId: widgetId
    });

    if (!this.phases.has(phaseKey) || this.phases.get(phaseKey).duration) {
      return;
    }

    var phase = this.phases.get(phaseKey);
    phase.duration = performance.now() - phase.phaseStartTime;

    if (widgetArray) {
      phase.widgetArray = widgetArray;
    }

    if (widgetId) {
      phase.widgetId = widgetId;
    }

    this.phases.set(phaseKey, phase);
  };

  _proto.getNextPhaseToReport = function getNextPhaseToReport() {
    var latestStepIndex = this.phases.size - 1;
    var lastPhaseKey = this.indexToKey.get(latestStepIndex);
    return this.phases.get(lastPhaseKey);
  };

  _proto.getPhasePreviousTo = function getPhasePreviousTo(_ref5) {
    var name = _ref5.name,
        appId = _ref5.appId,
        widgetId = _ref5.widgetId;
    var currentPhase = this.phases.get(LoadingPhases._getIndexForPhase({
      name: name,
      appId: appId,
      widgetId: widgetId
    }));
    var previousPhaseIndex = this.indexToKey.get(currentPhase.index - 1);
    return this.phases.get(previousPhaseIndex);
  };

  _proto.getPhases = function getPhases(_temp) {
    var _ref6 = _temp === void 0 ? {} : _temp,
        appId = _ref6.appId;

    var phaseToNamedPhaseObject = function phaseToNamedPhaseObject(phase) {
      var _ref7;

      return _ref7 = {}, _ref7[phase.name] = phase, _ref7;
    };

    return Array.from(this.phases).filter(function (_ref8) {
      var phaseKey = _ref8[0];

      var _phaseKey$split = phaseKey.split('_'),
          appIdOfPhase = _phaseKey$split[1];

      return appId && appIdOfPhase === appId || !appId;
    }).map(function (_ref9) {
      var phase = _ref9[1];
      return phaseToNamedPhaseObject(phase);
    });
  };

  _proto.createCodeParsingPhaseIfNotExist = function createCodeParsingPhaseIfNotExist(_temp2) {
    var _ref10 = _temp2 === void 0 ? {} : _temp2,
        appId = _ref10.appId,
        widgetId = _ref10.widgetId;

    var phaseKey = LoadingPhases._getIndexForPhase({
      name: CODE_PARSING_PHASE_NAME,
      appId: appId,
      widgetId: widgetId
    });

    if (!this.phases.has(phaseKey)) {
      var appLoadStartTime = this.times.getLoadStartTime({
        appId: appId,
        widgetId: widgetId
      });
      this.phases.set(phaseKey, {
        phaseStartTime: appLoadStartTime,
        index: 0,
        name: CODE_PARSING_PHASE_NAME
      });
      this.indexToKey.set(0, phaseKey);
    }
  };

  return LoadingPhases;
}();

export { LoadingPhases as default };